export const user = state => state.user
export const checkPermissions = state => permissions => {
  console.log(state.permissions)
  console.log(permissions)
  console.log(permissions.some(permission => state.permissions.includes(permission)))
  return permissions.some(permission => state.permissions.includes(permission))
}
